import React, { createContext, useEffect, useState, useCallback } from "react";
import Swal from "sweetalert2";
import caAPI from "../services/caAPI";
import { trackPromise } from "react-promise-tracker";
import AtendimentoService from "../services/AtendimentoService";

export const AtendentesContext = createContext({});

export function AtendentesProvider({ children }) {
  const [listaAtendentes, setListaAtendentes] = useState([]);
  const [listaAtendentesGerenciados, setListaAtendentesGerenciados] = useState([]);
  const [mapaAtendentes, setMapaAtendentes] = useState(new Map());
  const [mapaAtendentesGerenciados, setMapaAtendentesGerenciados] = useState(new Map());
  
  useEffect(() => {
    const novoMapa = new Map();
    listaAtendentes.forEach((atendente) => {
      novoMapa.set(Number(atendente.id), atendente);
    });
    setMapaAtendentes(novoMapa);
  }, [listaAtendentes]);

  useEffect(() => {
    const novoMapa = new Map();
    listaAtendentesGerenciados.forEach((atendente) => {
      novoMapa.set(Number(atendente.id), atendente);
    });
    setMapaAtendentesGerenciados(novoMapa);
  }, [listaAtendentesGerenciados]);

  const recarregarListaAtendentes = () => {
    trackPromise(caAPI.atendimento.atendentes
      .listaAtendentesTransferencia()
      .then((res) => {
        let arrayAtendentes = res.data.sort((a, b) => {
          return (a.nome && b.nome && a.nome < b.nome && -1) || 0;
        });
        setListaAtendentes(arrayAtendentes);
      })
      .catch((err) =>
        Swal.fire({
          titleText: "Erro",
          text: "Houve um problema ao buscar a lista de atendentes  " + err,
          icon: "error",
        })
      ), 'loading-atendentes');
  };

  const recarregarListaAtendentesGerenciados = () => {
    caAPI.atendimento.atendentes
      .listaAtendentes()
      .then((res) => {
        let arrayAtendentes = res.data.sort((a, b) => {
          return (a.nome && b.nome && a.nome < b.nome && -1) || 0;
        });
        setListaAtendentesGerenciados(arrayAtendentes);
      })
      .catch((err) =>
        Swal.fire({
          titleText: "Erro",
          text: "Houve um problema ao buscar a lista de atendentes  " + err,
          icon: "error",
        })
      );
  };

  const resolverNomeAtendente = (idAtendente, padrao = "Não Atribuído") => {
    let atendente = mapaAtendentes.get(Number(idAtendente));
    return (atendente && atendente.nome) || padrao;
  };

  const testarAtendenteGerenciado = (idAtendente) => {
    return mapaAtendentesGerenciados.has(Number(idAtendente));
  };

  const validarUsuarioAtualAtendePorAtendimento = useCallback((atendimento) => {
    const idUsuario = Number(caAPI.getLocalState('idUsuario'))
    const idsUsuariosPermitidosVisualizar = caAPI.getLocalState('usuariosPermitidosVisualizar') || []
    // Se o atendente do atendimento for igual ao usuario atual ou estiver na lista de permitidos visualizar
    if([...idsUsuariosPermitidosVisualizar, Number(idUsuario)].includes(Number(atendimento?.atendente))) {
      return true
    }
    // Se houver a configuração contatosVeTudo e o atendente estiver qualificado E 
    // o atendente do atendimento for gerenciado pelo usuario atual OU se atendimento não tiver atendente atribuido e o usuario atual puder ver não atendidos
    if(
      AtendimentoService.testarUsuarioAtualVeOrigem(atendimento.origem?.id_contato_origem) && 
      (testarAtendenteGerenciado(atendimento?.atendente) || (caAPI.getLocalState('visualizaNaoAtendidos') && !atendimento?.atendente))) {
      return true
    }
    return false
  }, [mapaAtendentesGerenciados])

  return (
    <AtendentesContext.Provider
      value={{
        listaAtendentes,
        setListaAtendentes,
        listaAtendentesGerenciados,
        setListaAtendentesGerenciados,
        recarregarListaAtendentes,
        recarregarListaAtendentesGerenciados,
        resolverNomeAtendente,
        testarAtendenteGerenciado,
        mapaAtendentesGerenciados,
        validarUsuarioAtualAtendePorAtendimento
      }}
    >
      {children}
    </AtendentesContext.Provider>
  );
}
